import apiClient from '../lib/axios';

export type FulfillmentType = 'PICKUP' | 'DELIVERY';

export interface CreatePublicOrderItem {
  pharmacyProductId: string;
  quantity: number;
}

export interface CreatePublicOrderInput {
  fulfillmentType: FulfillmentType;
  deliveryAddress?: string;
  deliveryNotes?: string;
  notes?: string;
  items: CreatePublicOrderItem[];
  pickupBranchId?: string;
}

export interface PublicOrderResponse {
  id: string;
  trackingUUID: string;
  status: string;
  totalAmount: string;
  createdAt: string;
  trackingUrl: string;
}

export async function createPublicOrder(input: CreatePublicOrderInput): Promise<PublicOrderResponse> {
  const { data } = await apiClient.post<PublicOrderResponse>('/public-orders', input);
  return data;
}

export interface PickupBranch {
  id: string;
  name: string;
  address: string;
  phoneNumber: string | null;
}

export async function listPickupBranches(): Promise<PickupBranch[]> {
  const { data } = await apiClient.get<PickupBranch[]>('/public-orders/branches');
  return data;
}

// Tracking response types
export type OrderStatus = 'PENDING' | 'IN_PROGRESS' | 'READY_FOR_PICKUP' | 'COMPLETED' | 'CANCELLED';

export interface TrackingMedication {
  productName: string;
  quantity: number;
  instructions?: string;
  price: string;
  durationDays?: number;
  expiresAt?: string;
  insuranceCoverageAmount?: string;
  finalPrice?: string;
}

export interface TrackingPharmacyChain {
  name: string;
  logoUrl?: string;
  phoneNumber?: string | null;
}

export interface TrackingPickupBranch {
  name: string;
  address: string;
  phoneNumber?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface TrackingStatusLog {
  status: OrderStatus;
  timestamp: string;
}

export interface PublicTrackingResponse {
  trackingUUID: string;
  status: OrderStatus;
  fulfillmentType: FulfillmentType;
  medications: TrackingMedication[];
  pharmacyChain: TrackingPharmacyChain;
  pickupBranch?: TrackingPickupBranch | null;
  statusTimeline: TrackingStatusLog[];
  createdAt: string;
  updatedAt: string;
  completedAt?: string;
  notificationsEnabled: boolean;
  insuranceIdImageUrl?: string;
  nationalIdImageUrl?: string;
}

export async function trackMyOrder(trackingUUID: string): Promise<PublicTrackingResponse> {
  const { data } = await apiClient.get<PublicTrackingResponse>(`/public-orders/track/${trackingUUID}`);
  return data;
}

export interface CustomerOrderListItem {
  trackingUUID: string;
  status: string;
  totalAmount: string;
  itemCount: number;
  createdAt: string;
}

export async function listMyOrders(): Promise<CustomerOrderListItem[]> {
  const { data } = await apiClient.get<CustomerOrderListItem[]>('/public-orders/mine');
  return data;
}
